import { useGetPositionsInNotEducationProgramsLazyQuery } from "~/schemas/generated/graphql";
import { useEffect } from "react";
import { debounce, get } from "lodash";

const useGetAllFilteredPositionsForSelect = () => {
  const [getPositionQuery, { data, loading, fetchMore }] =
    useGetPositionsInNotEducationProgramsLazyQuery({
      variables: {
        page: 0,
        count: 25,
      },
      fetchPolicy: "cache-and-network",
      notifyOnNetworkStatusChange: true,
    });

  useEffect(() => {
    getPositionQuery();
  }, []);

  const positions = [
    ...get(
      data,
      "EducationGetter.getPositionsInNotEducationPrograms.items",
      []
    ).map(({ id, code, name, isEducationProgram }) => {
      return {
        value: id,
        label: `${code}. ${name}`,
        isDisabled: Boolean(isEducationProgram),
      };
    }),
  ];

  const intersectionObserverPositions = () => {
    if (positions.length < 25) {
      return;
    }
    const page = Math.ceil(positions.length / 25);
    fetchMore({
      variables: {
        page,
        count: 25,
      },

      updateQuery: ({ EducationGetter }, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return { EducationGetter };
        }
        return {
          EducationGetter: {
            ...EducationGetter,
            getPositionsInNotEducationPrograms: {
              ...EducationGetter.getPositionsInNotEducationPrograms,
              items: [
                ...EducationGetter.getPositionsInNotEducationPrograms.items,
                ...get(
                  fetchMoreResult,
                  "EducationGetter.getPositionsInNotEducationPrograms.items",
                  []
                ),
              ],
            },
          },
        };
      },
    });
  };

  const searchTextPositions = debounce((searchText) => {
    getPositionQuery({
      variables: {
        page: 0,
        name: searchText,
      },
    });
  });

  return {
    positions,
    intersectionObserverPositions,
    searchTextPositions,
    loadingPositions: loading,
  };
};

export default useGetAllFilteredPositionsForSelect;
